import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Node.js is a server-side JavaScript runtime built on Chrome's V8 engine. Its non-blocking, event-driven model makes it a natural fit for applications that need a persistent connection between browser and server — live feeds, chat, notifications and streaming.",
    "Our Node.js developers build lightweight, highly scalable services and APIs that stay fast under load. Because the same language runs on the front and back end, we ship features quickly and keep your stack consistent from database to browser.",
];

const FEATURES = [
    { title: "Asynchronous & event-driven", text: "Non-blocking I/O keeps the server responsive while it handles thousands of concurrent connections." },
    { title: "Single-threaded, highly scalable", text: "An event loop lets one process serve huge request volumes without spinning up a thread per user." },
    { title: "Very fast execution", text: "Running on Google's V8 engine, Node compiles JavaScript to native machine code for real speed." },
    { title: "Rich module ecosystem", text: "A vast library of packages lets us assemble robust features without reinventing the basics." },
];

const CHECKS = [
    "Single-page applications",
    "Data-streaming applications",
    "I/O-bound applications",
    "JSON API services",
    "Real-time, data-intensive apps",
];

export default function Nodejs() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Web Development" title="Node.js Development" eyebrowAs="span">
                    Fast, event-driven back ends for real-time apps, APIs and data-heavy services — built on the same V8 engine that powers Chrome.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
